import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import CartSettingForm from '@/components/v2/ecommerce/CartSettingForm.vue';
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
import OperatingLeadTimeMixin from '@/helpers/vue_mixins/v2/OperatingLeadTimeMixin';
let CartSetting = class CartSetting extends mixins(RouterParamsAppMixin, CleverTapEventsMixin, OperatingLeadTimeMixin) {
    mounted() {
        this.viewCartSettingsPage();
    }
};
CartSetting = __decorate([
    Component({
        components: {
            CartSettingForm,
            PageTitle,
            BaseOverlayLoader,
        },
    })
], CartSetting);
export default CartSetting;
